"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Spinner_1 = __importDefault(require("../../../../common/Spinner/Spinner"));
var Toast_1 = require("../../../../common/Toast");
var org_hook_1 = require("../../../../context/OrgContext/org.hook");
var getValVideo_1 = require("../../../../lib/getValVideo");
var HeaderBar_1 = __importDefault(require("../../../../theme/headerbar/HeaderBar"));
var Mutation_1 = require("../Graphql/Mutation");
var Queries_1 = require("../Graphql/Queries");
var SensitationTable_1 = __importDefault(require("./SensitationTable"));
var VideoForm_1 = __importDefault(require("./VideoForm"));
function Sensitation() {
    var _a, _b, _c, _d, _e, _f, _g;
    var t = (0, react_i18next_1.useTranslation)().t, organization = (0, org_hook_1.useOrg)().organization, _h = (0, react_1.useState)(false), clickStatus = _h[0], setClickStatus = _h[1], _j = (0, react_1.useState)({
        en: '',
        fr: '',
        rn: '',
    }), languages = _j[0], setLanguages = _j[1], _k = (0, react_1.useState)(null), editSensitationParam = _k[0], setEditSensitationParam = _k[1], _l = (0, react_1.useState)({
        loading: false,
        error: null,
        success: null,
    }), status = _l[0], setStatus = _l[1];
    var _m = (0, client_1.useLazyQuery)(Queries_1.GET_SENSITATION, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
    }), callSensitation = _m[0], sensitationResponse = _m[1], _o = (0, client_1.useMutation)(Mutation_1.UPSERT_SENSITATION, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
    }), callUpsertSensitation = _o[0], upsertSensitationResponse = _o[1], _p = (0, client_1.useMutation)(Mutation_1.DELETE_SENSITATION, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
    }), callDeleteSensitation = _p[0], deleteSensitationResponse = _p[1];
    (0, react_1.useEffect)(function () {
        if (status === null || status === void 0 ? void 0 : status.success) {
            var timer_1 = setTimeout(function () {
                setStatus(function (prevState) { return (__assign(__assign({}, prevState), { success: null })); });
            }, 5000);
            return function () { return clearTimeout(timer_1); };
        }
    }, [status === null || status === void 0 ? void 0 : status.success]);
    (0, react_1.useEffect)(function () {
        if (organization.id !== '') {
            callSensitation({
                variables: {
                    organization_id: organization.id,
                    published: true,
                },
            });
        }
    }, [organization.id]);
    var reformatSensitationParam = function () {
        var reformat = {
            id: null,
            title: JSON.stringify(languages),
            description: JSON.stringify(languages),
            thumbnail: languages,
            video: languages,
            sorting: null,
            organization_id: organization.id,
        };
        setEditSensitationParam(reformat);
    }, saveSensitation = function (formData) {
        window.scrollTo(0, 0);
        setStatus(function (prevState) { return (__assign(__assign({}, prevState), { loading: true })); });
        var thumbnailArr = (0, getValVideo_1.getVal)(formData.thumbnail), videoArr = (0, getValVideo_1.getVal)(formData.video), variables = {
            title: formData.title,
            sensitation_media: {
                thumbnail: thumbnailArr,
                video: videoArr,
            },
            description: formData.description,
            sensitation_id: formData.sensitation_id
                ? formData.sensitation_id
                : null,
            sorting: formData.sorting,
            organization_id: organization.id,
            published: true,
        };
        callUpsertSensitation({
            variables: variables,
        })
            .then(function (res) {
            setStatus(function (prevState) { return (__assign(__assign({}, prevState), { success: res.data.upsertSensitation, loading: false })); });
            reformatSensitationParam();
            callSensitation({
                variables: {
                    organization_id: organization.id,
                    published: true,
                },
            });
        })
            .catch(function (e) {
            setStatus(function (prevState) { return (__assign(__assign({}, prevState), { loading: false })); });
            return e;
        });
    };
    var onSensitationDelete = function (params) {
        callDeleteSensitation({
            variables: {
                sensitation_id: params.id,
                organization_id: organization.id,
            },
        })
            .then(function (res) {
            setStatus(function (prevState) { return (__assign(__assign({}, prevState), { success: res.data.deleteSensitation, loading: false })); });
            callSensitation({
                variables: {
                    organization_id: organization.id,
                    published: true,
                },
            });
        })
            .catch(function (e) {
            setStatus(function (prevState) { return (__assign(__assign({}, prevState), { loading: false })); });
            return e;
        });
    }, onSensitationEdit = function (params) {
        window.scrollTo(0, 0);
        var reformat = {
            sensitation_id: params.id,
            title: params.title,
            description: params.description,
            thumbnail: languages,
            video: languages,
            sorting: params.sorting,
            organization_id: organization.id,
        };
        setEditSensitationParam(reformat);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        ((deleteSensitationResponse === null || deleteSensitationResponse === void 0 ? void 0 : deleteSensitationResponse.loading) ||
            status.loading ||
            (upsertSensitationResponse === null || upsertSensitationResponse === void 0 ? void 0 : upsertSensitationResponse.loading)) && react_1.default.createElement(Spinner_1.default, null),
        (deleteSensitationResponse === null || deleteSensitationResponse === void 0 ? void 0 : deleteSensitationResponse.data) && (react_1.default.createElement(Toast_1.ToastSuccess, { autoClose: 5000, closeOnClick: true, draggable: true, hideProgressBar: true, message: t((_a = deleteSensitationResponse === null || deleteSensitationResponse === void 0 ? void 0 : deleteSensitationResponse.data) === null || _a === void 0 ? void 0 : _a.deleteSensitation), newestOnTop: false, onClose: true, pauseOnFocusLoss: true, pauseOnHover: true, position: 'top-center', rtl: false })),
        ((_b = upsertSensitationResponse === null || upsertSensitationResponse === void 0 ? void 0 : upsertSensitationResponse.data) === null || _b === void 0 ? void 0 : _b.upsertSensitation) && (react_1.default.createElement(Toast_1.ToastSuccess, { autoClose: 5000, closeOnClick: true, draggable: true, hideProgressBar: true, message: t((_c = upsertSensitationResponse === null || upsertSensitationResponse === void 0 ? void 0 : upsertSensitationResponse.data) === null || _c === void 0 ? void 0 : _c.upsertSensitation), newestOnTop: false, onClose: true, pauseOnFocusLoss: true, pauseOnHover: true, position: 'top-center', rtl: false })),
        react_1.default.createElement(HeaderBar_1.default, { onSave: function () { return setClickStatus(true); }, title: 'guide' },
            react_1.default.createElement(VideoForm_1.default, { languages: languages, editSensitationParam: editSensitationParam, sortingList: (_e = (_d = sensitationResponse === null || sensitationResponse === void 0 ? void 0 : sensitationResponse.data) === null || _d === void 0 ? void 0 : _d.getSensitationByOrganization) !== null && _e !== void 0 ? _e : [], saveClickStatus: clickStatus, updateSaveClickStatus: function () { return setClickStatus(false); }, saveSensitationData: function (data) { return saveSensitation(data); } }),
            react_1.default.createElement(SensitationTable_1.default, { list: (_g = (_f = sensitationResponse === null || sensitationResponse === void 0 ? void 0 : sensitationResponse.data) === null || _f === void 0 ? void 0 : _f.getSensitationByOrganization) !== null && _g !== void 0 ? _g : [], onSensitationDelete: function (payload) { return onSensitationDelete(payload); }, onSensitationEdit: function (payload) { return onSensitationEdit(payload); } }))));
}
exports.default = Sensitation;
